module.exports = __webpack_public_path__ + "static/media/Minus.fdd6039a.svg";